import { render, staticRenderFns } from "./BrokerFirmContactsList.vue?vue&type=template&id=1aa730d2&scoped=true"
import script from "./BrokerFirmContactsList.vue?vue&type=script&lang=js"
export * from "./BrokerFirmContactsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa730d2",
  null
  
)

export default component.exports